import request from './request'

export default {
  formatarProntuario: prontuario => {
    console.log(prontuario)
    const data = prontuario
    return request({
      url: '/gpt/formatarProntuario',
      method: 'post',
      data
    })
  }
}
